import { render } from "./TagContainer.vue?vue&type=template&id=61667a7f&scoped=true&ts=true"
import script from "./TagContainer.vue?vue&type=script&lang=ts"
export * from "./TagContainer.vue?vue&type=script&lang=ts"

import "./TagContainer.vue?vue&type=style&index=0&id=61667a7f&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61667a7f"]])

export default __exports__